/**
 * @desc: -  彩票报表
 * @author: danny
 */

import {DateGroup,RangeGroup,SearchGroup,Pagintaion,Bread} from "./ReportComponent.jsx";
import React from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as baseAction from '../../../actions/baseAction'
import * as userAction from '../../../actions/userAction'
import * as commonAction from "../../../actions/commonAction";
import * as reportAction from "../../../actions/reportAction";

import { importDatePrototype } from '../../../helpers/unit'
import ReportBase from './ReportBase.jsx'
import Popup from "../../../components/modal/popup.jsx";
import LotteryBetRecord from './popPage/LotteryBetRecord.jsx'
import LotteryAddRecord from './popPage/LotteryAddRecord.jsx'
import LotteryChangeRecord from './popPage/LotteryChangeRecord.jsx'
class LotteryReport extends ReportBase{
	constructor(props){
		super(props)
		this.state.orderBy = 'username';
	}
	refer(){
		const {startDate,endDate,rangeIndex,pageNum,orderBy,sort,rangeOptionValue,searchValue} = this.state;
		this.props.$$REPORT.getWinLossSummery(startDate,endDate,searchValue,rangeOptionValue,pageNum,orderBy,sort)
	}
	
	breadRefer(){

	}
	
	render(){
		
		const __base = this.props.__BASE.toJS();
		const __report = this.props.__REPORT.toJS();
		
		if(!__report.current_view ) return <div></div>
		const {searchValue,orderBy,sort,popUpCurrent} = this.state;
		return <div className="lottery-report-container report-commer-container">
			<div className="title-warp">
				<h6 className="title">彩票报表</h6>
			</div>
			
			<div className="tool-warp">
				
				<DateGroup defaultStart={this.state.startDate.split(' ')[0]}
				           defaultEnd={this.state.endDate.split(' ')[0]}
				           onStartChange={this.onStartChange}
				           onEndChange={this.onEndChange}/>
				
				<RangeGroup title="状态："
				            rangeMenuInfo={[{title:"个人",optionValue:0},{title:"团队",optionValue:1}]}
				            rangeMenuClick={this.rangeMenuClick}/>
				
				<SearchGroup searchValue={searchValue} onChange={this.searchChange}/>
				
				<label onClick={this.refer} className="blue-button">查询</label>
			</div>
			<div className="info-warp">
				<label>本级 : <Bread onChange={this.breadChange} bread={__report.current_view.bread}/></label>
				<label className="warming-color"><i className="warming-icon"></i>选择查询条件之后进行查询</label>
			</div>
			<div className="table-warp">
				<div className="table-title-warp">
					<label className={orderBy != "username"?"":sort == 'desc' ?"active-up":"active-down"}
					       onClick={()=>this.tableTitleClick('username')}>用户名<i></i></label>
					<label className={orderBy != "sum_deposit"?"":sort == 'desc' ?"active-up":"active-down"}
					       onClick={()=>this.tableTitleClick('sum_deposit')}>充值<i></i></label>
					<label className={orderBy != "sum_withdraw"?"":sort == 'desc' ?"active-up":"active-down"}
					       onClick={()=>this.tableTitleClick('sum_withdraw')}>提现<i></i></label>
					<label className={orderBy != "sum_prize"?"":sort == 'desc' ?"active-up":"active-down"}
					       onClick={()=>this.tableTitleClick('sum_prize')}>投注金额<i></i></label>
					<label className={orderBy != "sum_bonus"?"":sort == 'desc' ?"active-up":"active-down"}
					       onClick={()=>this.tableTitleClick('sum_bonus')}>中奖金额<i></i></label>
					<label className={orderBy != "sum_point"?"":sort == 'desc' ?"active-up":"active-down"}
					       onClick={()=>this.tableTitleClick('sum_point')}>返点金额<i></i></label>
					<label className={orderBy != "sum_activity"?"":sort == 'desc' ?"active-up":"active-down"}
					       onClick={()=>this.tableTitleClick('sum_activity')}>活动奖金<i></i></label>
					<label className={orderBy != "sum_wages"?"":sort == 'desc' ?"active-up":"active-down"}
					       onClick={()=>this.tableTitleClick('sum_wages')}>日工资<i></i></label>
					<label className={orderBy != "profit_loss"?"":sort == 'desc' ?"active-up":"active-down"}
					       onClick={()=>this.tableTitleClick('profit_loss')}>盈亏金额<i></i></label>
					<label>操作</label>
				</div>
				{
					__report.current_view.result && __report.current_view.result.result && __report.current_view.result.result.length > 0 ?
						__report.current_view.result.result.map((item,index)=>{
							return <div className="title-body-warp" key={index}>
								<label>{item.username}</label>
								<label>{_.round(item.sum_deposit, 4)}</label>
								<label>{_.round(item.sum_withdraw, 4)}</label>
								<label>{_.round(item.sum_prize, 4)}</label>
								<label>{_.round(item.sum_bonus, 4)}</label>
								<label>{_.round(item.sum_point, 4)}</label>
								<label>{_.round(item.sum_activity, 4)}</label>
								<label>{_.round(item.sum_wages, 4)}</label>
								<label className={item.profit_loss > 0 ? "green" : "red"}>{item.profit_loss > 0 ? "+" : ""}{_.round(item.profit_loss, 4)}</label>
								<label>
									{
										['投注','追号','帐变'].map((item,index) => {
											return <span onClick={()=>{this.popUpToggle("operate-"+index)}} className="operate" key={index}>{item}</span>
										})
									}
								</label>
								
							</div>
					}):<div className="title-body-warp"><p className=" no-data">没有获取到数据</p></div>
				}
				{
					__report.current_view.result ?
						<div>
							<div className="title-footer-warp">
								<label>本页合计</label>
								<label>-</label>
								<label>-</label>
								<label>{_.round(__report.current_view.result.cur_total.sum_prize, 4)}</label>
								<label>{_.round(__report.current_view.result.cur_total.sum_bonus, 4)}</label>
								<label>{_.round(__report.current_view.result.cur_total.sum_point, 4)}</label>
								<label>{_.round(__report.current_view.result.cur_total.sum_activity, 4)}</label>
								<label>{_.round(__report.current_view.result.cur_total.sum_wages, 4)}</label>
								<label className={__report.current_view.result.cur_total.profit_loss > 0 ? "green" : "red"}>{__report.current_view.result.cur_total.profit_loss > 0 ? "+" : ""}{_.round(__report.current_view.result.cur_total.profit_loss, 4)}</label>
								<label>-</label>
							</div>
							<div className="title-footer-warp">
								<label>总合计</label>
								<label>-</label>
								<label>-</label>
								<label>{_.round(__report.current_view.result.all_total.sum_prize, 4)}</label>
								<label>{_.round(__report.current_view.result.all_total.sum_bonus, 4)}</label>
								<label>{_.round(__report.current_view.result.all_total.sum_point, 4)}</label>
								<label>{_.round(__report.current_view.result.all_total.sum_activity, 4)}</label>
								<label>{_.round(__report.current_view.result.all_total.sum_wages, 4)}</label>
								<label className={__report.current_view.result.all_total.profit_loss > 0 ? "green" : "red"}>{__report.current_view.result.all_total.profit_loss > 0 ? "+" : ""}{_.round(__report.current_view.result.all_total.profit_loss, 4)}</label>
								<label>-</label>
							</div>
						</div>
						:
						<div>
							<div className="title-footer-warp">
								<label>本页合计</label>
								<label>-</label>
								<label>-</label>
								<label>0</label>
								<label>0</label>
								<label>4</label>
								<label>0</label>
								<label>0</label>
								<label className="positive">0</label>
								<label>-</label>
							</div>
							<div className="title-footer-warp">
								<label>总合计</label>
								<label>-</label>
								<label>-</label>
								<label>0</label>
								<label>0</label>
								<label>4</label>
								<label>0</label>
								<label>0</label>
								<label className="negative">0</label>
								<label>-</label>
							</div>
						</div>
				}
				
			</div>
			
			<ul className="warning-warp">
				<div className="title">
					<i className="warning-icon"></i>
					<p>温馨提示：</p>
				</div>
				<ul>
					<li >此处帐变为彩票帐变</li>
					<li >彩票统计时间为：02:00:00--02:00:00</li>
				</ul>
			</ul>
			
			{
				this.renderPage('')
			}
			
			<Popup display={popUpCurrent == "operate-0"} className="indexPobup" width={1040}  height={600} onclose={()=>{this.popUpToggle('none')}}>
				<LotteryBetRecord></LotteryBetRecord>
			</Popup>
			<Popup display={popUpCurrent == "operate-1"} className="indexPobup" width={1040}  height={600} onclose={()=>{this.popUpToggle('none')}}>
				<LotteryAddRecord></LotteryAddRecord>
			</Popup>
			<Popup display={popUpCurrent == "operate-2"} className="indexPobup" width={1040}  height={600} onclose={()=>{this.popUpToggle('none')}}>
				<LotteryChangeRecord></LotteryChangeRecord>
			</Popup>
		</div>
	}
}

reactMixin(LotteryReport.prototype, ImmutableMixin);

function mapStateToProps(state) {
	return {
		__BASE: state.base,
		__USER: state.user,
		__REPORT:state.report
	}
}

function mapDispatchToProps(dispatch) {
	return {
		$$USER: bindActionCreators(userAction, dispatch),
		$$COMMON: bindActionCreators(commonAction, dispatch),
		$$BASE: bindActionCreators(baseAction, dispatch),
		$$REPORT:bindActionCreators(reportAction, dispatch),
	}
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(LotteryReport)
